/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeclineLadderChallengeBody
 */
export interface DeclineLadderChallengeBody {
    /**
     * Optional reason for declining the challenge
     * @type {string}
     * @memberof DeclineLadderChallengeBody
     */
    reason?: string;
}

/**
 * Check if a given object implements the DeclineLadderChallengeBody interface.
 */
export function instanceOfDeclineLadderChallengeBody(value: object): value is DeclineLadderChallengeBody {
    return true;
}

export function DeclineLadderChallengeBodyFromJSON(json: any): DeclineLadderChallengeBody {
    return DeclineLadderChallengeBodyFromJSONTyped(json, false);
}

export function DeclineLadderChallengeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeclineLadderChallengeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function DeclineLadderChallengeBodyToJSON(json: any): DeclineLadderChallengeBody {
    return DeclineLadderChallengeBodyToJSONTyped(json, false);
}

export function DeclineLadderChallengeBodyToJSONTyped(value?: DeclineLadderChallengeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

